import { useEffect, useState, useContext } from "react";
import { BookMark, Controls, Bplay, Hindit, BookMarkNext, Medias, CurrentDuration, CurrentAudioUrl, AddedSongs, UserAudios, DownloadedSongs, CurrentAudioRef, Aos, SongsHistory, Fsing, DurFlag, Cposition, IsMusicComponent, MediaFile } from "../global";
import { useHistory } from "react-router-dom";
import { IonFooter, IonItem, IonLabel, isPlatform, IonAlert, IonToast } from "@ionic/react";
import MusicPlayer from "./musicplayer";
import AddSongModal from "./addsongmodal";
import YouTubeFab from "./youtubeFab";
import FabPlayer from "./fabplayer";
import SingersList from "./singerslist";
import { HTTP } from '@awesome-cordova-plugins/http';
import { File } from '@awesome-cordova-plugins/file';
import { Menu} from "@material-ui/core";
import { Share } from "@capacitor/share";
import {Printer} from "@awesome-cordova-plugins/printer"
import { Insomnia } from "@awesome-cordova-plugins/insomnia";
import { NativeAudio } from '@capacitor-community/native-audio'
import { MediaSession } from "@jofr/capacitor-media-session"
import { Media } from "@awesome-cordova-plugins/media";


function Music(props){

    const songName = props.songName
    const hsongName = props.hsongName
    const songList = props.songList
    const songPath = props.songPath
    const colorh = props.colorh
    const fon = props.fon
    const colori = props.colori
    const anchorEl = props.anchorEl
    const setAnchorEl = props.setAnchorEl
    const share_url = props.share_url.replace(/\s/g, "%20")
   



    
    const [bookMark, dispatch] = useContext(BookMark);
    const [showAlert3, setShowAlert3] = useState(false);
    const [showAlert4, setShowAlert4] = useState(false);
    const [, setCurrentAudioUrl] = useContext(CurrentAudioUrl)
    const [loaded, setLoaded] = useState(false);
    const [fsing, setFsing] = useContext(Fsing)
    const [, setDownloadedSongs] = useContext(DownloadedSongs)
    const [fabClose, setFabClose] = useState(true);
    const [addSongDetails, setAddSongDetails] = useState({"type": "youtube", "singer": "", "path": "", "link": songPath });
    const [addSong, setAddSong] = useState(false);
    const [addedSongs, setAddedSongs] = useContext(AddedSongs)
    const [controlsg, ] = useContext(Controls);
    const [controls, setControls] = useState(controlsg)
    const [duration, setDuration] = useState(0);
    const audi = useContext(CurrentAudioRef)
    const [isDownloaded, setIsDownloaded] = useState(false);
    const [durFlag, setDurFlag] = useContext(DurFlag)
    const [cposition, setCposition] = useContext(Cposition)
    const [bplay, ] = useContext(Bplay);
    let history = useHistory();
    const [bookMarkNext, setBookMarkNext] = useContext(BookMarkNext);
    const [ppb, setPpb] = useContext(Medias);
    const [current, setCurrent] = useContext(CurrentDuration);
    const [dur, setDur] = useState(0);
    const [hindit, ] = useContext(Hindit);
    const [showActionSheet, setShowActionSheet] = useState(false);
    const [userAudios, setUserAudios] = useContext(UserAudios)
    const [devi, setDevi] = useState(fsing[songName] ?? 0);
    const [showToast, setShowToast] = useState(false);
    const [toastText, setToastText] = useState("");
    const [, setSongsHistory] = useContext(SongsHistory)
    const [aos, ] = useContext(Aos);
    const [isDownloading, setIsDownloading] = useState(false)
    const [, setIsMusicComponent] = useContext(IsMusicComponent)
    const [mediaFile, setMediaFile] = useContext(MediaFile);
    const [downloadCheckDone, setDownloadCheckDone] = useState(false)

    useEffect(()=>{
      if(fsing[songName] && devi!==fsing[songName]) setDevi(fsing[songName]) 
    }, [fsing])

    let inputs2 = [];
    bookMark.forEach((ele) => {
     inputs2.push({
      name: ele.name,
      type: "radio",
      label: ele.name ?? "Default",
      value: ele.name,
     });
    });
    inputs2.push({
     name: "New List",
     type: "radio",
     label: "New List",
     value: "New Bookmark",
    });
    

    function getIonColor(color){
      if(color === "light") {
        return "#f4f5f8"
      }
      if(color=== "secondary") {
        return "#FCEFAA"
      }
      if(color=== "dark") {
        return "#222428"
      }
    }
    


 function addtobookmark(folder) {
    let check = false;
    if(folder==="") folder=undefined;
    bookMark.forEach((dele) => {
     if (dele.name === folder) {
      dele.songs.forEach((ele) => {
       if (ele.name === songName) {
        check = true;
        setToastText("Song is already added to the list");
        setShowToast(true);
       }
      });
     }
    });
    if (!check) {
     dispatch({ type: "add", folder: folder, name: songName, path: songPath });
  
     setToastText("Added to the list");
     setShowToast(true);
    }
   }

    function formatTime(seconds) {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return [h, m > 9 ? m : h ? "0" + m : m || "0", s > 9 ? s : "0" + s].filter((a) => a).join(":");
       }

       useEffect(()=>{
        setIsMusicComponent(true)
        return(()=>{
          setIsMusicComponent(false)
        })
       },[])

      
       useEffect(()=>{
        setSongsHistory((prev)=>{
          let dum = {...prev}
          var currentDate = new Date();
          var day = currentDate.getDate();
          var month = currentDate.getMonth() + 1; // Note: January is 0
          var year = currentDate.getFullYear();

          day = (day < 10) ? '0' + day : day;
          month = (month < 10) ? '0' + month : month;
          let date = year + '-' + month + '-' + day;
          let time = currentDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
          if(!dum[date]) dum[date]=[]
          dum[date].push({"name": songName, "hname":hsongName ? hsongName : songName,  "path": songPath, "time": time })
          return dum
        })
       }, [])
      
       useEffect(() => {
        if (aos === "true") {
         Insomnia.keepAwake()
         return () => {
          Insomnia.allowSleepAgain()
         };
        } 
       }, []);

       useEffect(() => {
        if(bplay.fold && userAudios[songName] && userAudios[songName].type === "youtube"){
          for (let i=0; i< addedSongs[songName].length; i++) {
            if(addedSongs[songName][i].type !== "youtube"){
              let link = addedSongs[songName][i]
              setUserAudios((prev)=>{
                let dum = {...prev}
                dum[songName] = {"id": i, "type": link.type, "linkname": link.singer, "hlinkname":link.singer,  "linkaddress": link.path}
                return dum
              })
              return
            }
          }
          setUserAudios((prev)=>{
            let dum = {...prev}
            dum[songName] = null
            return dum
          })
        } 
       }, [])

    useEffect(()=>{
        MediaSession.setPlaybackState({playbackState:"none"}).catch((err)=>{console.error(err)})
        if(mediaFile){
        mediaFile.stop()
        if(isPlatform("android") && !isPlatform("mobileweb")) mediaFile.release()
        }
        setMediaFile(null)
        if(audi.current) audi.current.pause()
        setCurrentAudioUrl(null)
        setPpb(false)
        return(()=>{
          setDurFlag(0)
        })
    },[])



       useEffect(() => {
        const handleOnlineStatusChange = () => {
         if(navigator.onLine && audi.current && !(audi.current.duration && isFinite(audi.current.duration))){
          audi.current.load();
         }
        }
      
        window.addEventListener('online', handleOnlineStatusChange)
        window.addEventListener('offline', handleOnlineStatusChange)
      
        return () => {
         window.removeEventListener('online', handleOnlineStatusChange)
         window.removeEventListener('offline', handleOnlineStatusChange)
        }
       }, [])

       async function downloadedFile(filePath){
        try{
          await NativeAudio.preload({
            assetId: "fire",
            assetPath: filePath,
            audioChannelNum: 1,
            isUrl: true
          })
          setIsDownloaded(true)
          setDownloadedSongs((prev)=>{
            let dum = {...prev}
            let nsongName = (props.vname && !userAudios[songName] ? props.vname : songName)
            if(!dum[nsongName]) dum[nsongName] = {}
            let singer = (userAudios[nsongName] ? userAudios[nsongName] : songList[devi]).linkname;
            dum[nsongName][singer] = {link: songPath, filepath: filePath}
            return dum
          })
          let duration = await NativeAudio.getDuration({
            assetId: 'fire'
          })
          setDuration(formatTime(duration.duration.toFixed(0)));
          setDurFlag(duration.duration)
          setMediaFile(Media.create(filePath)) 
          await NativeAudio.unload({
            assetId: 'fire'
          })
        } catch(err) {
        }
        setDownloadCheckDone(true)
      }

      useEffect(() => {
        setDownloadCheckDone(false)
        MediaSession.setPlaybackState({playbackState:"none"}).catch((err)=>{console.error(err)})
        if(mediaFile){
          mediaFile.stop()
          if(isPlatform("android") && !isPlatform("mobileweb")) mediaFile.release()
        }
        if(audi.current) audi.current.pause()
        setDuration(0);
        setDurFlag(0);
        setDur(0);
        setCposition(0);
        setTimeout(()=>{
          setCurrent(0);
          setCurrentAudioUrl(userAudios[songName] ? userAudios[songName].linkaddress : songList[devi].linkaddress)
        },100)
        setPpb(false)
        setIsDownloaded(false);
        createNotification((userAudios[songName] ? userAudios[songName] : songList[devi]).linkname, songName, false)
        let filePath =  (isPlatform("ios") ? File.documentsDirectory + "Downloads/" : File.dataDirectory) + (userAudios[songName] && userAudios[songName].type === "file" ? userAudios[songName].linkaddress : (props.vname && !userAudios[songName] ? props.vname : songName).replace(/\s+/g, '_') + "-" + (userAudios[songName] ? userAudios[songName] : songList[devi]).linkname.replace(/\s+/g, '_') + ".mp3"); 
        if (!isPlatform("desktop") && !isPlatform("mobileweb")) downloadedFile(filePath)
        else setDownloadCheckDone(true)
       }, [devi, userAudios]);

       useEffect(()=>{
        if(duration) createNotification((userAudios[songName] ? userAudios[songName] : songList[devi]).linkname, songName, true)
        if(duration && mediaFile){
          if(bplay.fold){
            mediaFile.play()
          setTimeout(()=>{
            if(audi.current && isPlatform("ios") && !isPlatform("mobileweb")) audi.current.play()
            MediaSession.setPlaybackState({playbackState:"playing"}).catch((err)=>{console.error(err)})  
          },1000)
          setPpb(true);
        }
        }
       },[duration, mediaFile, audi.current])

      
      
      
      function createNotification(singer, songName, isDownloaded){
        let metadata = {
          title: songName,
          artist: singer,
          album: "Vaishnava Songs",
          artwork:[
            { src: "/splash.png", sizes: '512x512', type: 'image/png' }
          ]
        }
        const actionsAndHandlers = [
          ['play', () => { 
            if(isDownloaded){
                mediaFile.play()
                if(audi.current && isPlatform("ios") && !isPlatform("mobileweb")) audi.current.play();
            }else{
              audi.current.play();
            } 
            setPpb(true);
            MediaSession.setPlaybackState({playbackState:"playing"}).catch((err)=>{console.error(err)})
           }],
          ['pause', () => {
            if(isDownloaded){
              mediaFile.pause()
              if(audi.current && isPlatform("ios") && !isPlatform("mobileweb")) audi.current.pause()
              }else{
                audi.current.pause();
              }
              setPpb(false);
            MediaSession.setPlaybackState({playbackState:"paused"}).catch((err)=>{console.error(err)})
          }],
          ['previoustrack', () => { seekLeft() }],
          ['nexttrack', () => { seekRight() }],
          ['seekbackward', () => {
            seekLeft()
          }],
          ['seekforward', () => {
            seekRight()
          }],
          ['seekto', (details) => {
            if (details.seekTime) {
              seekToValue(details.seekTime)
            }
          }],
          ['stop', () => {
            if(isDownloaded){
              mediaFile.pause()
              if(audi.current && isPlatform("ios") && !isPlatform("mobileweb")) audi.current.pause()
              }else{
                audi.current.pause();
              }
              setPpb(false);
            MediaSession.setPlaybackState({playbackState:"none"}).catch((err)=>{console.error(err)})
          }],
        ]
        MediaSession.setMetadata(metadata).then(()=>{
            for (const [action, handler] of actionsAndHandlers) {
              MediaSession.setActionHandler({action:action}, handler).catch((err)=>{console.error(err)})
            }
          }).catch((err)=>{console.error(err)})
      }
      
       function download() {
        if (isDownloaded) {
         setToastText("Song is already Downloaded");
         setShowToast(true);
        } else if(isDownloading) {
          setToastText("Song is getting downloaded, please wait!");
          setShowToast(true);
        } 
        else {
        if(isPlatform("desktop") || isPlatform("mobileweb")){
          window.open((userAudios[songName] ? userAudios[songName] : songList[devi]).linkaddress, '_blank');
        }else{
          setIsDownloading(true)
         let filePath = (isPlatform("ios") ? File.documentsDirectory + "Downloads/" : File.dataDirectory) + (props.vname && !userAudios[songName] ? props.vname : songName).replace(/\s+/g, '_') + "-" + (userAudios[songName] ? userAudios[songName] : songList[devi]).linkname.replace(/\s+/g, '_') + ".mp3";
         setToastText("Downloading started");
         setShowToast(true);
         HTTP.downloadFile((userAudios[songName] ? userAudios[songName] : songList[devi]).linkaddress, {}, {}, filePath).then(response => {
                  setShowToast(false);
           setToastText("Song downloaded, you can play this song offline from the app. You can manage all your downloaded songs in the History tab of the Lists section");
           setShowToast(true);
          setDuration(0);
          setDurFlag(0);
          if(mediaFile){
          mediaFile.stop()
          if(isPlatform("android") && !isPlatform("mobileweb")) mediaFile.release()
          }
          setCposition(0);
          if(audi.current) {audi.current.pause()}
          setCurrent(0);
           setPpb(false);
           downloadedFile(filePath)
           setIsDownloaded(true);
           setIsDownloading(false)
           MediaSession.setPlaybackState({playbackState:"paused"}).catch((err)=>{console.error(err)})
              }).catch(err => {
                console.error(err)
                 setShowToast(false);
                 setIsDownloading(false)
           setToastText("Error occured while downloading, try again later");
           setShowToast(true);
              })
            }
        }
       }   



 useEffect(() => {
    if (audi.current) {
    audi.current.onloadedmetadata = () => {
       setDur(audi.current.duration);
       if(!loaded) setLoaded(true);
      }
     };
   }, [audi.current]);
  
   useEffect(() =>{
    if (downloadCheckDone && !isDownloaded && bplay.fold && loaded) {
      MediaSession.setPlaybackState({playbackState:"playing"}).catch((err)=>{console.error(err)})
      setTimeout(()=>{
        if(audi.current) audi.current.play() 
      },100)
      setPpb(true);
    }
   },[downloadCheckDone, isDownloaded, loaded, audi, bplay])


  

    function playon() {
        if (audi.current) {
         if (!ppb) {
          if (audi.current.duration && isFinite(audi.current.duration)) {
           setTimeout(()=>{
            audi.current.play();
           },1)
           setPpb(!ppb);
           MediaSession.setPlaybackState({playbackState:"playing"}).catch((err)=>{console.error(err)})
          } else {
           setToastText("loading, please wait or check your internet connection or else try again later");
           setShowToast(true);
          }
         }
     
         if (ppb) {
          audi.current.pause();
          setPpb(!ppb);
          MediaSession.setPlaybackState({playbackState:"paused"}).catch((err)=>{console.error(err)})
         }
        }
       
      }
     
      function playoff() {
       if (!ppb) {
        mediaFile.play();
        setTimeout(()=>{
          if(audi.current && isPlatform("ios") && !isPlatform("mobileweb")) audi.current.play();
         },1)
        setPpb(true);
        MediaSession.setPlaybackState({playbackState:"playing"}).catch((err)=>{console.error(err)})
       }
       if (ppb) {
        mediaFile.pause();
        if(audi.current && isPlatform("ios") && !isPlatform("mobileweb")) audi.current.pause()
        setPpb(false);
        MediaSession.setPlaybackState({playbackState:"paused"}).catch((err)=>{console.error(err)})
       }
      }

      function seekLeft(){
        if(bplay.fold){
          if(bookMarkNext !== "shuffle") setBookMarkNext("left");
          history.push("/lists/" + (!isNaN(bplay.fold) ? bplay.fold - 1 : bplay.fold));
        }else{
        if (duration) {
          mediaFile.getCurrentPosition().then((position) => {
            if (position > 10) mediaFile.seekTo(position * 1000 - 10000);
            else mediaFile.seekTo(1);
           });
        if(audi.current && isPlatform("ios") && !isPlatform("mobileweb")) audi.current.play();
      }
        else{
          if(audi.current && audi.current.duration && isFinite(audi.current.duration)){
          audi.current.currentTime -= 10;
          audi.current.play()
          }
        } 
        setPpb(true);
        MediaSession.setPlaybackState({playbackState:"playing"}).catch((err)=>{console.error(err)})
      }
      }

      function seekRight(){
        if(bplay.fold){
          if(bookMarkNext !== "shuffle") setBookMarkNext("right");
          history.push("/lists/" + (!isNaN(bplay.fold) ? bplay.fold - 1 : bplay.fold));
        }else{
        if (duration){
          mediaFile.getCurrentPosition().then((position) => {
            if (mediaFile.getDuration() - position > 11) mediaFile.seekTo(position * 1000 + 10000);
            else mediaFile.seekTo(mediaFile.getDuration() - 1);
           });
        if(audi.current && isPlatform("ios") && !isPlatform("mobileweb")) audi.current.play();
       }
        else{
        if(audi.current && audi.current.duration && isFinite(audi.current.duration)){
          audi.current.currentTime += 10;
          audi.current.play()
        }
        } 
        setPpb(true);
        MediaSession.setPlaybackState({playbackState:"playing"}).catch((err)=>{console.error(err)})
      }
      }

      function seekToValue(value){
        if (duration){ 
         mediaFile.seekTo(value*1000)
        if(audi.current && isPlatform("ios") && !isPlatform("mobileweb")) audi.current.play();
        setCposition(value);
        }
        else {
          if (audi.current && audi.current.duration && isFinite(audi.current.duration)) {
           audi.current.currentTime = value;
           audi.current.play()
          }
         }
        setPpb(true);
        MediaSession.setPlaybackState({playbackState:"playing"}).catch((err)=>{console.error(err)})
      }
     

    return(
       <div className="print-hide"> 

<Menu classesid="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>

         <IonItem button={isPlatform('desktop') ? true : false}         
        
          onClick={() => {
           setAnchorEl(null);
           setShowAlert3(true);
          }}
         >
          <IonLabel style={{ fontFamily: `${fon}`, width:"145px", textAlign:"center" }}>{hindit ? "बुकमार्क/प्लेलिस्ट":"Bookmark/Playlist"}</IonLabel>
         </IonItem>

         <IonItem button={isPlatform('desktop') ? true : false}         
          onClick={() => {
           setAnchorEl(null);
           setAddSong(true);
          }}
         >
          <IonLabel style={{ fontFamily: `${fon}`, width:"115px", textAlign:"center" }}>{hindit ? "ऑडियो जोड़ें":"Add Audio"}</IonLabel>
         </IonItem>
         
      
         <IonItem button={isPlatform('desktop') ? true : false}         

          onClick={async () => {
            setAnchorEl(null)
            if(isPlatform("desktop")){
              navigator.clipboard.writeText(`${songName} Song: ${share_url}`)
              .then(() => {
                setToastText("Text copied to clipboard. You can now paste it wherever you want to share it.");
                setShowToast(true);
              })
              .catch((error) => {
                console.error('Could not copy text: ', error);
              });
            }else{
              try{
             await Share.share({
             title: "Share this Treasure",
             text: `${songName} Song: ${share_url}`,
             dialogTitle: "Share this song with devotees",
            });
          }catch(err){
            console.error(err)
          }
          }
           }}
         >
          <IonLabel style={{ fontFamily: `${fon}`, width:"115px", textAlign:"center" }}>{hindit ? "शेयर":"Share"}</IonLabel>
         </IonItem>

         <IonItem button={isPlatform('desktop') ? true : false}         
          onClick={() => {
           setAnchorEl(null);
           setTimeout(()=>{
            if(isPlatform("desktop") || isPlatform("mobileweb")) window.print() 
            else Printer.print(null, {name: songName})
           },1000)
          }}
         >
          <IonLabel style={{ fontFamily: `${fon}`, width:"115px", textAlign:"center" }}>{hindit ? "प्रिंट / पीडीएफ":"Print/PDF"}</IonLabel>
         </IonItem>

         {isPlatform("desktop") || isPlatform("mobileweb") ? null : <IonItem button={isPlatform('desktop') ? true : false}          
     
          onClick={() => {
           setAnchorEl(null);
           window.open((userAudios[songName] ? userAudios[songName] : songList[devi]).linkaddress, '_blank');
          }}
         >
          <IonLabel style={{ fontFamily: `${fon}`, width:"115px", textAlign:"center" }}>{hindit ? "डाउनलोड":"Download"}</IonLabel>
         </IonItem>}

         <IonItem button={isPlatform('desktop') ? true : false}
         lines={!(userAudios[songName] && userAudios[songName].type === "youtube") ? "inset": "none"}        
          onClick={() => {
           setAnchorEl(null);
           history.push("/home/settings");
          }}
         >
          <IonLabel style={{ fontFamily: `${fon}`, width:"115px", textAlign:"center" }}>{hindit ? "सेटिंग":"Settings"}</IonLabel>
         </IonItem>

         {!(userAudios[songName] && userAudios[songName].type === "youtube") ? <IonItem className="lhide" button={isPlatform('desktop') ? true : false}         
          lines="none"
          onClick={() => {
            if(controls === "true"){
              setControls("false")
            }else{
              setControls("true")
            }
            setAnchorEl(null);
          }}
         >
          <IonLabel style={{ fontFamily: `${fon}`, width:"115px", textAlign:"center" }}>{hindit ? (controls === "false" ? "मिनिमाइज़ कंट्रोल्स":"मेक्सिमाइज़ कंट्रोल्स") : (controls === "false" ? "Minimize Controls":"Maximize Controls")}</IonLabel>
         </IonItem> : null }

       </Menu>

       <IonAlert
    isOpen={showAlert3}
    onDidDismiss={() => setShowAlert3(false)}
    cssClass="my-custom-class"
    header={"Select a List"}
    inputs={inputs2}
    buttons={[
     {
      text: "Cancel",
      role: "cancel",
      cssClass: "warning",
      handler: () => {},
     },
     {
      text: "Ok",
      handler: (res) => {
       if (res === "New Bookmark") {
        setShowAlert4(true);
       } else {
        addtobookmark(res);
       }
      },
     },
    ]}
   />

   <IonAlert
    isOpen={showAlert4}
    onDidDismiss={() => setShowAlert4(false)}
    cssClass="my-custom-class"
    header={"New List"}
    inputs={[
     {
      name: "newmark",
      type: "text",
      placeholder: "Name of the List",
     },
    ]}
    buttons={[
     {
      text: "Cancel",
      role: "cancel",
      cssClass: "warning",
      handler: () => {},
     },
     {
      text: "Ok",
      handler: (res) => {
       addtobookmark(res.newmark);
      },
     },
    ]}
   />
        
{!(userAudios[songName] && userAudios[songName].type === "youtube") && controls === "false" && (songList[0].linkname !== "dummy" || addedSongs[songName]) ? <div className="lhide" style={{ height: `${isPlatform("ios") ? "98px" : "88px"}`, backgroundColor:`${getIonColor(props.colori)}` }}></div> : null}
   
   <SingersList
   showActionSheet={showActionSheet}
   setShowActionSheet={setShowActionSheet}
   setAddSong={setAddSong}
   addedSongs={addedSongs}
   setAddedSongs={setAddedSongs}
   userAudios={userAudios}
   setUserAudios={setUserAudios}
   audi={audi}
   duration={duration}
   setPpb={setPpb}
   hindit={hindit}
   name={songName}
   hindiName={hsongName}
   defaultSingers={songList[0].linkname !== "dummy" ? songList : []}
   setFsing={setFsing}
   devi={devi}
   setDevi={setDevi}
    />
   
       {(userAudios[songName] && userAudios[songName].type === "youtube") ?
   <YouTubeFab
   setShowActionSheet={setShowActionSheet}
   colorh={colorh}
    /> : null}
     
     {!(userAudios[songName] && userAudios[songName].type === "youtube") && (songList[0].linkname !== "dummy" || addedSongs[songName]) ?
     <FabPlayer
     controls={controls}
     duration={duration}
     audi = {audi}
     isDownloaded={isDownloaded}
     download={download}
     colorh={colorh}
     durFlag={durFlag}
     seekLeft={seekLeft}
     seekRight={seekRight}
     bplay={bplay}
     history={history}
     bookMarkNext={bookMarkNext}
     setBookMarkNext={setBookMarkNext}
     ppb={ppb}
     cposition={cposition}
     current={current}
     dur={dur}
     playoff={playoff}
     playon={playon}
     setShowActionSheet={setShowActionSheet}
     fabClose={fabClose}
     setFabClose={setFabClose}
     name={songName}
     hindiName={hsongName}
     userAudios={userAudios}
     audioDetails={songList[devi]}
      />
 
   : null}
  {isPlatform("ios") && !(userAudios[songName] && userAudios[songName].type === "youtube") && (controls === "false") && (songList[0].linkname !== "dummy" || addedSongs[songName]) ? <div className="iphoneb lhide"></div> : null}
  <IonToast isOpen={showToast} onDidDismiss={() => setShowToast(false)} message={toastText} duration={4000} />
    
    <AddSongModal
       addSongDetails={addSongDetails}
       setAddSongDetails={setAddSongDetails}
       addSong={addSong}
       addedSongs={addedSongs}
       setAddSong={setAddSong}
       setAddedSongs={setAddedSongs}
       setUserAudios={setUserAudios}
       audi={audi}
       duration={duration}
       setToastText={setToastText}
       setShowToast={setShowToast}
       setPpb={setPpb}
       name={songName}
       singersList={songList[0].linkname !== "dummy" ? songList : []}
        />

        {!(userAudios[songName] && userAudios[songName].type === "youtube")  && controls === "false" && (songList[0].linkname !== "dummy" || addedSongs[songName]) ? (
    <IonFooter>
      <MusicPlayer
      colori={colori} 
      duration={duration}
      fon={fon}
      audi = {audi}
      isDownloaded={isDownloaded}
      isDownloading={isDownloading}
      download={download}
      colorh={colorh}
      durFlag={durFlag}
      seekLeft={seekLeft}
      seekRight={seekRight}
      seekToValue={seekToValue}
      bplay={bplay}
      history={history}
      bookMarkNext={bookMarkNext}
      setBookMarkNext={setBookMarkNext}
      ppb={ppb}
      cposition={cposition}
      setCposition={setCposition}
      current={current}
      setCurrent={setCurrent}
      dur={dur}
      hindit={hindit}
      playoff={playoff}
      playon={playon}
      setShowActionSheet={setShowActionSheet}
      name={songName}
      hindiName={hsongName}
      userAudios={userAudios}
      audioDetails={songList[devi]}
       />
    </IonFooter>
   ) : null}
        </div>
    );

}

export default Music